import { render, staticRenderFns } from "./ChangeLateralityModal.vue?vue&type=template&id=51fcd657&scoped=true&"
import script from "./ChangeLateralityModal.vue?vue&type=script&lang=js&"
export * from "./ChangeLateralityModal.vue?vue&type=script&lang=js&"
import style0 from "./ChangeLateralityModal.vue?vue&type=style&index=0&id=51fcd657&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fcd657",
  null
  
)

export default component.exports